import cx from 'classnames';
import PropTypes from 'prop-types';

import { OrderedList } from './OrderedList';
import styles from './OrderedList.css';

const OrderedListPlugin = ({
  className,
  ORDERED_LIST_TAG,
  ...attributes
} = {}) => ({
  renderElement: OrderedList({
    className: cx(styles.orderedList, className),
    ORDERED_LIST_TAG,
    ...attributes,
  }),
});

OrderedListPlugin.propTypes = {
  className: PropTypes.string,
  ORDERED_LIST_TAG: PropTypes.node,
};

export { OrderedListPlugin };
